import styled from '@emotion/styled';
import { KizenTypography } from '__app/typography';
import { SettingsContentCard } from '__components/Card/Card';
import Input from '__components/Kizen/Input';

export const StyledPage = styled.section`
  margin: 20px 0;
`;

export const StyledSettingsContentCard = styled(SettingsContentCard)`
  margin: 20px auto;
`;

export const StyledStepHeader = styled(KizenTypography)`
  margin-bottom: 20px;
  &:not(:first-of-type) {
    margin-top: 25px;
  }
`;

export const StyledTableToolbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 36px;
  margin-bottom: 20px;
`;

export const StyledExecutionsTableWrapper = styled.div`
  margin: 20px 0 0;
`;

export const StyledSearchInput = styled(Input)`
  max-width: 200px;

  label {
    margin: 0;
  }

  .input-wrapper {
    margin: 0;
    background-color: var(--color-background-white);
  }

  input {
    min-width: 0;
    padding-right: 0;
  }
`;
